/**
 * Listing filters live in the URL (?minPrice=&maxPrice=&inStock=1&sort=price_asc) so a filtered
 * listing can be shared and the back button undoes a change. The backend matches a product when
 * ONE of its variants passes every filter, and lists it once.
 */

export const LISTING_SORTS = [
  { value: "newest", label: "Newest" },
  { value: "price_asc", label: "Price: low to high" },
  { value: "price_desc", label: "Price: high to low" },
];

const SORT_VALUES = LISTING_SORTS.map((s) => s.value);
const FILTER_KEYS = ["minPrice", "maxPrice", "inStock", "sort"];

const parsePrice = (raw) => {
  if (typeof raw !== "string" || raw.trim() === "") return undefined;
  const n = Number(raw);
  return Number.isFinite(n) && n >= 0 ? n : undefined;
};

/** Filters from Next's router.query; anything malformed is dropped rather than sent. */
export const filtersFromQuery = (query = {}) => {
  let minPrice = parsePrice(query.minPrice);
  let maxPrice = parsePrice(query.maxPrice);
  if (minPrice !== undefined && maxPrice !== undefined && minPrice > maxPrice) {
    [minPrice, maxPrice] = [maxPrice, minPrice];
  }

  return {
    minPrice,
    maxPrice,
    inStock: query.inStock === "1" || query.inStock === "true",
    sort: SORT_VALUES.includes(query.sort) && query.sort !== "newest" ? query.sort : undefined,
  };
};

/** Query params for the URL and the API: only filters that are set. */
export const filtersToQuery = ({ minPrice, maxPrice, inStock, sort } = {}) => {
  const query = {};
  if (minPrice !== undefined) query.minPrice = String(minPrice);
  if (maxPrice !== undefined) query.maxPrice = String(maxPrice);
  if (inStock) query.inStock = "1";
  if (sort && sort !== "newest") query.sort = sort;
  return query;
};

/** How many filters are on (the badge on the Filter button). Sort counts as one. */
export const activeFilterCount = (filters) => {
  const query = filtersToQuery(filters);
  return (
    (query.minPrice || query.maxPrice ? 1 : 0) + (query.inStock ? 1 : 0) + (query.sort ? 1 : 0)
  );
};

/** router.query without the filter keys. */
export const withoutFilters = (query = {}) =>
  Object.fromEntries(Object.entries(query).filter(([key]) => !FILTER_KEYS.includes(key)));
